import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { getLeadTracks } from "@/config/endpoints";
import type { EligibleTrackUser } from "../types/stageTypes";

/** Who a lead's track can be handed to — users whose role holds the track at
 *  "Own" and who belong to the lead's branch, with their current load. */
export function useEligibleTrackUsers(
  leadId: string | number | null | undefined,
  trackId: number | null | undefined,
  enabled = true
) {
  return useQuery({
    queryKey: ["track-eligible-users", leadId, trackId],
    enabled: Boolean(enabled && leadId && trackId),
    staleTime: 30_000,
    queryFn: async (): Promise<EligibleTrackUser[]> => {
      const { data } = await axiosInstance.get(
        `${getLeadTracks}/users/eligible/${leadId}/${trackId}`
      );
      return data?.data ?? [];
    },
  });
}
